import React, { useState, useEffect } from 'react';
import {PageContainer, usePages} from '@ignitesales/neuro-application';
import GuidePageContainer from "@ignitesales/neuro-application/src/neuro-guide/guide-framework/components/GuidePageContainer";
import {useDialogueGuideSettings} from "../hooks/useDialogueGuideSettings.mjs";
import {useDialogueContext} from "../hooks/useDialogueContext.mjs";
import ContactFormPage from "./ContactFormPage";
import ActionService from '../services/ActionService.mjs';
import { useAnswers } from '@ignitesales/neuro-application/src/neuro-guide/hooks';

/**
 * Component was made to override product page experience if we need to show contact page prior to recommendations
 */
const DialoguePageContainer = (props) => {
    const { contactFormCompleted, contactPageIsActive } = useDialogueContext();
    const { contactBeforeSummary } = useDialogueGuideSettings();
    const shouldShowContact =  contactBeforeSummary === true && !contactFormCompleted && contactPageIsActive;
    const contactPageOverride = shouldShowContact
        ? { SummaryPage: ContactFormPage, DetailsPage: ContactFormPage, RemoteSummaryPage: ContactFormPage }
        : {};
    const { currentPageUrl, getCurrentPage } = usePages();
    const [ oldPage, setOldPage ] = useState(getCurrentPage());
    const [ oldUrl, setOldUrl ] = useState(currentPageUrl);
    const answerService = useAnswers();
    const answers = Object.values(answerService.answers);

    //TODD: finish implementing tick - need past page and current page
    useEffect(() => {
        (async () => {
            const page = getCurrentPage();
            if(oldPage != page || currentPageUrl != oldUrl)
                ActionService.tick('onLeave', oldPage, oldUrl, answers).then();
            ActionService.tick('onLoad', page, currentPageUrl, answers).then();
            setOldPage(page);
            setOldUrl(currentPageUrl);
        })();
    }, [currentPageUrl]);

    return <PageContainer {...props} {...contactPageOverride} />;
};
DialoguePageContainer.propTypes = {
    ...GuidePageContainer.propTypes
};

export default DialoguePageContainer;
